// KPI içe aktarma sihirbazı — UI kopyası TEK kaynak (M16 T11; report-import-copy kalıbı).
// Bileşenlerde satır içi durum/sonuç string'i yazılmaz; e2e spec'i buradaki metinleri eşler.

export const KPI_IMPORT_COPY = {
  subtitle: "Excel, PDF veya Word dosyasındaki performans tablosunu veri setine aktarın.",
  steps: ["Yükle", "Eşleştir", "Hesaplama ve Önizleme", "Aktar"] as const,
  upload: {
    dropLabel: "Dosya seç",
    dropHint:
      "Excel (.xlsx) · PDF · Word (.docx) — en fazla 50 MB. Çok sayfalı Excel ve rapor PDF'leri desteklenir.",
    /** TODO-KPI-25 — 8 sayfa üstü 6'şar sayfalık kesitlerde sırayla okunur; toplam tavan 48 sayfa. */
    pdfNote:
      "PDF'te yalnız performans tablosu sayfalarını içeren kesit önerilir (en fazla 48 sayfa). 8 sayfadan uzun PDF 6'şar sayfalık kesitlerde sırayla okunur — süre ve maliyet sayfa sayısıyla artar, tüm raporu yüklemek eşleştirme kalitesini düşürür.",
    sizeWarn: "Dosya büyük — yükleme ve okuma birkaç dakika sürebilir.",
    rejectType: "Yalnız .xlsx, .pdf ve .docx yüklenebilir",
    rejectXls: "Dosyayı .xlsx olarak kaydedip yeniden yükleyin",
    rejectSize: "Dosya 50 MB sınırını aşıyor",
    uploading: "Yükleniyor",
    uploaded: "YÜKLENDİ",
    // 2026-10-08 — iş yalnız taraması temiz dosyada açılır; commit sonrası 1 sn aralıkla yoklanır
    scanning: "Dosya taranıyor…",
    scanBlocked:
      "Dosya güvenlik taramasından geçemedi — bu dosya kullanılamaz. Dosyayı kontrol edip yeniden yükleyin.",
    scanError: "Dosya taranamadı — biraz sonra yeniden yükleyin.",
    scanTimeout: "Tarama uzun sürdü — biraz sonra yeniden deneyin",
    creatingJob: "İş oluşturuluyor…",
    processingTitle: "Dosya işleniyor",
    stageQueued: "Kuyrukta — işleme sırası bekleniyor",
    stageExtracting: "Dosya okunuyor",
    stageMapping: "Yapay zekâ satırları veri seti göstergeleriyle eşleştiriyor…",
    stageMappingHint: "(1–2 dk sürebilir, sayfadan ayrılabilirsiniz)",
    stageReady: "Hazır — Eşleştirme adımına geçilecek",
    stageFailed: "İşlem başarısız",
    noRows: "Tablo bulunamadı — performans tablosu sayfalarını içeren kesit yükleyin.",
    retry: "Yeniden dene",
    skipMapping: "Eşleştirmesiz devam et (tümünü elle eşleştir)",
    troubleLabel: "Sorun olursa:",
    cancelLabel: "Vazgeç",
    draftsTitle: "Taslak içe aktarımlar",
    draftsEmpty: "Bekleyen taslak yok.",
    // güvenlik/UX taraması 2026-10-08 (Codex #2): kaynak dosya silinmez — kanıt havuzunda kalır (K17)
    draftsNote:
      "Taslaklar 7 gün saklanır. Kaynak dosya kanıt havuzunda saklanır ve aktarılan hücrelere kaynak olarak bağlanır.",
    resume: "Kaldığı yerden devam →",
    deleteDraft: "Sil",
    deleteConfirmTitle: "Taslak içe aktarım silinsin mi?",
    deleteConfirmBody: (file: string): string =>
      `${file} için eşleştirme taslağı silinir; yüklenen dosya kanıt havuzunda kalır.`,
    deleteConfirm: "Sil",
    deleteFailed: "Taslak silinemedi",
    draftStep: (n: number): string => `Adım ${n.toString()}`,
    sheetsFound: (n: number, rows: number): string =>
      `${n.toString()} sayfa bulundu — ${rows.toString()} satır`,
  },
  mapping: {
    intro:
      "Yapay zekâ dosyadaki satırları veri setinizdeki göstergelerle eşleştirdi. Önerileri kontrol edin; eşleşmeyenler için mevcut göstergeye bağla, yeni gösterge olarak ekle ya da atla seçin. Hiçbir şey henüz yazılmadı.",
    introNoLlm:
      "Eşleştirme önerisi yok — tüm satırlar atlandı olarak geldi. Aktarmak istediğiniz satırlar için hedef gösterge seçin.",
    sheetAll: "Tüm sayfalar",
    /** P2-8 — sayfa atlama (bilanço gibi ilgisiz sayfalar) */
    sheetSkip: "Bu sayfayı atla",
    sheetUnskip: "Sayfayı dahil et",
    sheetSkippedTag: "atlandı",
    sheetSkipHelp:
      "Atlanan sayfanın satırları yazılmaz; yıl/işletme seçimi de istenmez. Kararı istediğiniz an geri alabilirsiniz.",
    sheetSuggestSkipTitle: (n: number): string =>
      `${n.toString()} sayfa performans tablosuna benzemiyor — atlamanız önerilir:`,
    sheetSuggestSkipItem: (name: string, hint: string | undefined): string =>
      hint ? `${name} (${hint})` : name,
    /** K14 — grup toplamı sayfası önerisi (otomatik atlanmaz). Nötr "Toplam": kapsamlı kullanıcıya
     * "Konsolide" yazılmaz (Y6, spec §4.3) — sihirbaz hem danışman hem müşteri kapsamında ortak. */
    groupTotalSheetHint:
      "Bu sayfa grup toplamı görünüyor — atlansın mı? (Toplam değerler sistemde hesaplanır.)",
    /** K13 — not/açıklama sayfası (yıl başlığı yok, uzun metin): otomatik atlanır, geri açılabilir */
    notesSheetTag: "not sayfası — atlandı",
    notesSheetOpenTag: "not sayfası",
    notesSheetsNotice: (names: string): string =>
      `Not sayfası olarak algılandı ve atlandı: ${names}. İçinde aktarılacak değer varsa sayfayı seçip "Sayfayı dahil et" deyin.`,
    /** K13 — yan yana çok bloklu sayfa */
    blocksNotice: (sheet: string, n: number): string =>
      `${sheet}: ${n.toString()} blok algılandı — her bloğun satırları kendi başlığı altında listelendi.`,
    /** K13 — "Toplam"/"Genel toplam" satırı */
    totalRowBadge: "sistem hesaplar",
    totalRowHelp:
      "Toplam satırı: değeri alt kırılımlardan sistem hesaplar, bu yüzden varsayılan olarak atlandı. İsterseniz kararı değiştirip dahil edebilirsiniz.",
    /** P1-1 — öneri aşaması uyarıları */
    warningsTitle: (n: number): string => `Öneri uyarıları (${n.toString()})`,
    warningsHint:
      'Bu satırlar "Kararınızı bekleyen" listesinde "model öneri vermedi" notuyla duruyor — hedefi elle seçin ya da atlayın.',
    columnsLabel: "Kolonlar:",
    editColumns: "✎ kolonları düzenle",
    closeColumns: "kolonları kapat",
    columnKinds: {
      label: "Gösterge",
      unit: "Birim",
      year: "Yıl",
      entity: "İşletme",
      ignore: "Yok say",
      description: "Açıklama",
      requirements: "Standart eşlemesi",
    } as const,
    columnSample: "Örnek",
    columnYear: "Yıl",
    columnEntity: "İşletme",
    entityNone: "— seçin —",
    entityUnresolved: (names: string[]): string =>
      `Eşlenmemiş işletme kolonu: ${names.join(", ")} — bu kolonlar için mevcut bir işletme seçin (Müşteri profili › İşletmeler).`,
    defaults: {
      title: "Dosyada olmayan bilgiler",
      yearLabel: "Yıl",
      yearHint: "Dosyada yıl kolonu yok — değerler hangi yıla yazılsın?",
      /** P2-6 — sayfa bazlı yıl (tek sayfa yüzünden tüm aktarım kilitlenmez) */
      yearSheetLabel: (sheet: string): string => `Yıl — ${sheet}`,
      yearSheetHint:
        "Bu sayfada yıl kolonu yok — değerler hangi yıla yazılsın? (ya da sayfayı atlayın)",
      entityLabel: "İşletme",
      /** K14 — seçici hangi sayfa(lar) için (Finar 7.2) */
      entityLabelForSheet: (names: readonly string[]): string =>
        names.length === 0
          ? "İşletme"
          : names.length === 1
            ? `İşletme — ${names[0] ?? ""} sayfası için`
            : `İşletme — ${names.join(", ")} sayfaları için`,
      entityHint: "Dosyada işletme kolonu yok — değerler hangi işletmeye yazılsın?",
      entityNone: "— işletme seçin —",
      required: "seçim zorunlu",
      blockNext: "İleri için yıl/işletme seçin",
    },
    counter: (matched: number, total: number, pending: number): string =>
      `${matched.toString()} / ${total.toString()} eşleşti · ${pending.toString()} kararınızı bekliyor`,
    filters: {
      pending: "Kararınızı bekleyen",
      uncertain: "Belirsiz",
      unmatched: "Eşleşmedi",
      matched: "Eşleşti",
      skipped: "Atlandı",
      all: "Tümü",
    } as const,
    acceptHigh: (n: number): string => `Yüksek güvenlileri toplu kabul (${n.toString()})`,
    skipSelected: (n: number): string => `Seçilileri atla (${n.toString()})`,
    search: "Satır ya da gösterge ara…",
    categoryAll: "Tüm kategoriler",
    th: {
      select: "Seç",
      row: "Dosyadaki satır",
      sample: "Örnek değer",
      suggestion: "Önerilen gösterge",
      confidence: "Güven",
      decision: "Kararınız",
    },
    unmatched: "EŞLEŞMEDİ",
    memoryHit: "önceki eşleşme",
    auto: "OTOMATİK",
    derivedHint: "ƒx hesaplanır",
    actions: {
      map: "Eşleştir",
      create: "Yeni gösterge olarak ekle",
      skip: "Atla",
      reported: "Raporlanan değer",
      create_breakdown: "Kırılım olarak ekle",
    } as const,
    actionHints: {
      map: "mevcut göstergeye yazılır",
      create: "katalog kodu seçin — veri setine eklenir",
      skip: "satır aktarılmaz",
      reported: "hesaplanan göstergeye raporlanan değer",
      create_breakdown: "üst göstergenin kırılım üyesi olarak eklenir",
    } as const,
    targetPlaceholder: "Gösterge kodu ya da adı…",
    targetNoResult: "Eşleşen gösterge yok",
    targetMissing: "hedef seçilmedi",
    band: { high: "yüksek", medium: "orta", low: "düşük" } as const,
    manualNote: "elle seçildi",
    pageLabel: (from: number, to: number, total: number): string =>
      total === 0 ? "0 satır" : `${from.toString()}–${to.toString()} / ${total.toString()}`,
    prev: "‹ Önceki",
    next: "Sonraki ›",
    autosaveNote:
      "Kararlarınız otomatik kaydedilir — daha sonra kaldığınız yerden devam edebilirsiniz.",
    saveDraft: "Taslağı kaydet",
    saving: "Kaydediliyor…",
    saved: "Taslak kaydedildi",
    saveFailed: "Taslak kaydedilemedi",
    back: "← Geri",
    nextStep: (pending: number): string =>
      pending > 0 ? `İleri — ${pending.toString()} karar bekliyor →` : "İleri →",
    emptyFilter: "Bu filtreyle eşleşen satır yok",
    clearFilter: "Filtreyi temizle",
  },
  /** T19 — müşteri yüzeyi kopyası: AI/yapay zekâ izi ve "yeni gösterge" yönlendirmesi YOK. */
  client: {
    stageMapping: "Satırlar veri seti göstergeleriyle eşleştiriliyor…",
    intro:
      "Dosyadaki satırlar veri setinizdeki göstergelerle eşleştirildi. Önerileri kontrol edin; eşleşmeyenler için mevcut göstergeye bağla ya da atla seçin. Hiçbir şey henüz yazılmadı.",
    readonlyNote: "salt okunur gösterge",
    createNotAllowedNote: "yeni gösterge eklenemez",
    /** Sunucu öneri satırı notu (`client-import-dto.ts` CLIENT_CLOSED_TARGET_NOTE) — elle eşlenik. */
    closedTargetNote: "önerilen hedef size kapalı",
    /** Sunucu öneri uyarısı (`client-import-dto.ts` CLIENT_MAPPING_WARNING) — elle eşlenik. */
    mappingWarning: "Bazı satırlar için öneri yok — hedefi elle seçin",
    /** Sunucu hata ayrıntısı (`client-import-dto.ts` CLIENT_IMPORT_FAILED_DETAIL) — elle eşlenik. */
    failedDetail: "Dosya işlenemedi — yeniden deneyin ya da dosyayı danışmanınıza iletin",
    accessSkippedTitle: (n: number): string => `Size kapalı hedefler (${n.toString()})`,
    accessSkippedHint: "Bu satırlar yazılmaz; danışmanınıza iletebilirsiniz.",
    forbiddenRows: (labels: string[]): string =>
      `Şu satırların hedefi size yazılabilir değil: ${labels.join(", ")} — satırları atlayın ya da danışmanınıza iletin.`,
  },
  preview: {
    loading: "Hesaplanıyor…",
    failed: "Önizleme alınamadı",
    cards: {
      create: { title: "YENİ DEĞER", hint: "boş hücrelere yazılacak" },
      update: { title: "DEĞİŞECEK", hint: "mevcut değerden farklı" },
      conflict: { title: "ÇAKIŞAN", hint: "başka değer var — kural uygulanır" },
      skipped: {
        title: "ATLANAN SATIR",
        hint: (derived: number, user: number): string =>
          `${derived.toString()} hesaplanan · ${user.toString()} kararınızla`,
      },
      derived: { title: "ETKİLENEN HESAPLAMA", hint: "türetilmiş gösterge yeniden hesaplandı" },
    },
    cellsTitle: (n: number): string => `Yazılacak hücreler (${n.toString()})`,
    th: {
      indicator: "Gösterge",
      entity: "İşletme",
      year: "Yıl",
      existing: "Sistemde",
      incoming: "Dosyada",
      outcome: "Sonuç",
    },
    outcome: {
      create: "yeni",
      update: "güncellenir",
      conflict: "çakışma",
      skip_derived: "hesaplanır — atlanır",
      unchanged: "aynı",
    } as const,
    policyTitle: "Çakışma kuralı",
    policy: {
      overwrite: {
        label: "Dosyadaki değeri yaz",
        hint: (n: number): string =>
          `${n.toString()} hücre güncellenir; eski değer kayıt geçmişinde kalır`,
      },
      keep_existing: { label: "Sistemdeki değeri koru", hint: "yalnız boş hücreler dolar" },
    },
    skippedTitle: (n: number): string => `Atlanan satırlar (${n.toString()})`,
    warningsTitle: (n: number): string => `Uyarılar (${n.toString()})`,
    /** P2-3 — aynı hedefe düşen hücrelerin tek tek listesi (katlanabilir) */
    dedupeDetails: (n: number): string =>
      `Aynı hedefe düşen hücreler — tek tek liste (${n.toString()})`,
    /** TODO-KPI-37 — karışık yazımlı sayfada belirsiz sayı ("1,234": binlik mi ondalık mı) */
    localeAmbiguous: (n: number): string =>
      `Belirsiz sayı yazımı (${n.toString()} hücre) — sayfa yazım biçimi: TR/EN`,
    localeAmbiguousHint:
      'Sayfada Türkçe ve İngilizce yazım karışık; "1,234" gibi hücreler Türkçe okundu (virgül ondalık, nokta binlik). Değerleri kontrol edin.',
    localeAmbiguousCell: (
      sheet: string,
      cell: string,
      raw: string,
      read: string,
      other: string,
    ): string => `${sheet} · ${cell}: "${raw}" → ${read} okundu (diğer okuma: ${other})`,
    /** P1-3 — birim çevrimi notu ("16.558.932 kWh → GJ ×0,0036") */
    convertedTag: "çevrildi",
    /** P2-8 — atlanan sayfalar */
    skippedSheets: (names: string[]): string =>
      `Atlanan sayfalar: ${names.join(", ")} — bu sayfaların satırları yazılmaz.`,
    missingYear: "Dosyada yıl kolonu yok ve yıl seçilmedi — eşleştirme adımında Yıl seçin.",
    missingYearSheets: (names: string[]): string =>
      `Şu sayfalarda yıl kolonu yok ve yıl seçilmedi: ${names.join(", ")} — eşleştirme adımında sayfa için yıl seçin ya da sayfayı atlayın.`,
    missingEntity:
      "Dosyada işletme kolonu yok ve işletme seçilmedi — eşleştirme adımında İşletme seçin.",
    unresolvedTitle: "Eşlenmemiş işletme kolonları",
    unresolvedBody:
      "Aşağıdaki işletme kolonları mevcut bir işletmeyle eşlenmedi; aktarım bu haliyle yapılamaz. Eşleştirme adımında kolonları düzenleyin.",
    newIndicators: (codes: string[]): string =>
      `Veri setine eklenecek yeni göstergeler: ${codes.join(", ")}`,
    derivedTitle: (n: number): string => `Yeniden hesaplanan göstergeler (${n.toString()})`,
    derivedEmpty: "Bu aktarım türetilmiş bir göstergeyi etkilemiyor.",
    derivedTh: {
      indicator: "Türetilmiş gösterge",
      entity: "İşletme",
      year: "Yıl",
      before: "Önce",
      after: "Sonra",
    },
    calcError: "HESAPLANAMADI",
    pendingXxx: "XXX",
    dash: "-",
    back: "← Geri (eşleştirmeye dön)",
    commit: (n: number): string => `Aktar — ${n.toString()} değer yazılacak →`,
    committing: "Aktarılıyor…",
    nothingToWrite: "Yazılacak hücre yok — eşleştirmeye dönüp hedef seçin.",
    commitFailed: "Hiçbir şey yazılmadı, eşleştirmeniz duruyor — tekrar deneyin.",
    alreadyCommitted: "Bu iş zaten aktarılmış. Yeni bir dosya yükleyin.",
  },
  commit: {
    title: "Aktarım tamamlandı",
    body: (n: number): string =>
      `${n.toString()} değer veri setine yazıldı. Tüm değerler tek seferde kaydedildi; kısmi aktarım olmaz — bir sorun çıksaydı hiçbir şey yazılmaz, eşleştirmeniz taslak olarak dururdu.`,
    stats: {
      created: "yeni değer",
      updated: "güncellenen değer",
      conflictsKept: "korunan mevcut değer",
      skipped: "atlanan satır",
      newIndicators: "yeni gösterge veri setine eklendi",
    },
    accessSkipped: (n: number): string =>
      `${n.toString()} satır size kapalı hedefe gittiği için yazılmadı:`,
    yearsNote: (from: number, to: number, viewFrom: number, viewTo: number): string =>
      `Dosyada ${from.toString()}–${to.toString()} yıllarına ait veriler de vardı; bunlar da aktarıldı ve Veri Girişi'ndeki yıl aralığı ${viewFrom.toString()}–${viewTo.toString()} olarak genişletildi.`,
    checkNote:
      'Bu aktarımla değişen göstergelerdeki "kontrol edildi ✓" işaretleri kaldırıldı — yeniden gözden geçirip işaretleyebilirsiniz (Özet › Kontrol bekleyen).',
    goTable: "Veri Girişi'ne git →",
    goSummary: "Özet'e git",
    newFile: "Yeni dosya yükle",
    record: (when: string, file: string): string =>
      `Aktarım kaydı: ${when} · ${file} · İşlem geçmişinde (Audit Log) görüntülenebilir.`,
  },
  /** Birim varyantı DR7 — önizlemede üç birim durumu (portalda da görünür: AI/üretim ifadesi YOK). */
  unit: {
    converted: (from: string, to: string, k: string): string => `${from} → ${to} · ×${k}`,
    incompatible: "Birim uyumsuz · yazılmayacak",
    incompatibleDetail: (file: string, target: string): string =>
      `dosya: ${file}, veri seti: ${target} — bu iki birim arasında çevrim yok`,
    changeForClient: "Müşteri için gösterge birimini değiştir",
    skipRow: "Satırı atla",
    unknown: (file: string, target: string): string =>
      `çevrim yapılmadan aktarılacak (dosya: ${file}, veri seti: ${target})`,
    unknownTag: "birim karşılaştırılamadı",
    counter: (c: number, i: number, u: number): string =>
      `${c.toString()} çevrildi · ${i.toString()} uyumsuz · ${u.toString()} karşılaştırılamadı`,
    commitSkipped: (n: number): string => `· ${n.toString()} satır atlanacak`,
    /** TODO-KPI-99: birimi karşılaştırılamayan hücreler atlanmaz — çevrim yapılmadan yazılır */
    commitUnconverted: (n: number): string => `· ${n.toString()} hücre çevrilmeden aktarılacak`,
    skipConfirmTitle: "Satır atlansın mı?",
    skipConfirmBody: (label: string): string =>
      `“${label}” satırı bu aktarımda yazılmaz; eşleştirmeyi geri alana kadar atlanmış kalır.`,
    skipConfirmAction: "Satırı atla",
    modalTitle: "Gösterge birimini değiştir",
    modalLoading: "Gösterge yükleniyor…",
    modalError: "Gösterge yüklenemedi",
    modalClose: "Kapat",
    appliedNote: "Birim güncellendi — önizleme yeniden hesaplanıyor.",
  },
  /**
   * Kırılım (spec §7.3, DR7) — danışman sihirbazı. Portal sihirbazında kırılım bloğu yok
   * (`create_breakdown` satırları sunucuda "önerilen hedef size kapalı" olur). Eylem adı
   * `mapping.actions.create_breakdown`; sunucu not metinleri `mapping-notes.ts` ile elle eşlenik.
   */
  breakdown: {
    newMember: "yeni",
    newGroup: "yeni grup",
    /** "Toplam çalışan › Cinsiyete göre › Kadın (yeni)" — grup da yeniyse "(yeni grup)". */
    targetPath: (parent: string, group: string, member: string, groupIsNew: boolean): string =>
      `${parent} › ${group} › ${member} (${groupIsNew ? "yeni grup" : "yeni"})`,
    suggestionsTitle: "Önerilen kırılımlar",
    suggestionsHint:
      "Kabul edilen kırılımlar aktarımda veri setine eklenir; atlananların satırları yazılmaz. Kararı istediğiniz an geri alabilirsiniz.",
    scope: (n: number): string => `Dosyadaki ${n.toString()} öneri`,
    acceptAll: "Tümünü kabul et",
    skipAll: "Tümünü atla",
    /** Tamlık hücresi — yıl (ya da işletme) başına dosyadaki toplam = alt kalemler. */
    yearCheck: (label: string, ok: boolean): string => `${label} ${ok ? "✓" : "—"}`,
    noTotalRow: "dosyada toplam satırı yok",
    existingGroup: "veri setinde mevcut grup",
    existingGroupHint: "Mevcut grubun tamlık ayarı veri setinden gelir.",
    th: {
      parent: "Üst gösterge",
      group: "Grup",
      members: "Üyeler",
      completeness: "Tamlık",
      role: "Hesaplama rolü",
      decision: "Karar",
    },
    state: { suggested: "Önerildi", accepted: "Kabul edildi", skipped: "Atlandı" },
    accept: "Kabul et",
    skip: "Atla",
    undo: "Geri al",
    role: { calculation: "hesap grubu", check: "doğrulama", none: "yalnız gösterim" },
    totalMatched: "Dosyadaki toplam eşleşti",
    representsAll: "Bu üyeler tüm kapsamı temsil ediyor",
    /** Kutunun altı — rol kuralı (fix round 1 I1, `rollupOnComplete`). */
    representsAllHint:
      "İşaretlenince toplam bu gruptan hesaplanır (üstte başka hesap grubu varsa bu grup doğrulama yapar); oran biriminde ya da dosyada tutmayan toplamda yalnız gösterilir.",
    systemComputesBadge: (n: string): string => `sistem hesaplar — kaynak ${n} = alt kalemler ✓`,
    /** Önizleme / eşleştirme — dosyadaki toplam üyelerin toplamından farklı (amber, asla kırmızı). */
    totalMismatchLine: (n: string, sum: string, diff: string): string =>
      `kaynak ${n} ≠ alt kalemler ${sum} (fark ${diff})`,
    fields: {
      parent: "Üst gösterge",
      group: "Grup",
      memberLabel: "Üye adı",
      otherGroupLabel: "Grup adı",
    },
    placeholders: { parent: "Üst gösterge seçin…", group: "Grup seçin…" },
    /** Alt satır doğrulaması — eksik alan kaydedilmez, satır işaretli kalır. */
    missing: {
      parent: "Üst gösterge seçin",
      dimension: "Grup seçin",
      memberLabel: "Üye adı girin",
    },
    missingHint: "Alanlar tamamlanmadan bu satır aktarılmaz.",
    previewTitle: (n: number): string => `Kırılımlar (${n.toString()})`,
    previewHint:
      "Toplam satırı alt kalemlerden hesaplanır; dosyadaki toplam yalnız karşılaştırma için gösterilir.",
    previewTotal: "toplam",
    newGroupOption: "+ Yeni grup",
    /** Sunucu notları (`mapping-notes.ts` KPI_BREAKDOWN_*) — elle eşlenik. */
    notes: {
      parentMissing: "üst gösterge sette yok",
      depth: "alt kalemin altına kırılım içe aktarmada açılamaz",
      permission: "Kırılım kurmak için katalog yönetme yetkisi gerekir",
      category: "Kategori altında kırılım grubu açmak Sistem Yöneticisi yetkisi gerektirir",
      totalMismatch: "kaynaktaki toplam kırılım toplamından farklı",
      breakdownOfTotal: "kırılım satırı toplam göstergeye eşlenmiş olabilir",
    },
    commitStat: "kırılım üyesi veri setine eklendi",
  },
  lockTitle: "İçe aktarma sürüyor",
  lockBody:
    "Müşteri ya da veri setini değiştirirseniz sihirbaz kapanır; eşleştirme taslağınız sunucuda durur.",
  genericError: "Bir hata oluştu",
} as const;
